// AI-CONTEXT: See docs/features/participatieladder-2026-3.md

/** Vaste volgorde en labels van de soorten waarde (besluit D1). */
export const TYPE_LABELS = {
    'direct financieel': 'Direct financieel',
    'indirect financieel': 'Indirect financieel',
    'niet-financieel': 'Niet-financieel',
}

/**
 * @typedef {import('./calculateParticipationPosts').PostRow} PostRow
 * @typedef {object} StakeholderView
 * @property {string} stakeholder
 * @property {number} total - Som van zijn posten
 * @property {Array<PostRow>} posts
 */

/**
 * Groepeert de posten van een 2026.3-uitkomst voor het scherm: per
 * stakeholder (in de volgorde van `calculation.stakeholders`, een onbekende
 * achteraan) en per soort waarde. Stakeholders zonder posten vallen weg.
 *
 * @param {{ posts: Array<PostRow>, perType: Object<string, number> }} impact
 * @param {Array<string>} [order] - `parameters.calculation.stakeholders`
 * @returns {{ stakeholders: Array<StakeholderView>, perType: Array<{key: string, label: string, value: number}> }}
 */
const buildParticipationPostsView = ({ posts = [], perType = {} }, order = []) => {
    const groups = new Map()
    posts.forEach((row) => {
        if (!groups.has(row.stakeholder)) groups.set(row.stakeholder, [])
        groups.get(row.stakeholder).push(row)
    })
    const rank = (sh) => (order.includes(sh) ? order.indexOf(sh) : order.length)
    const stakeholders = [...groups.entries()]
        .sort(([a], [b]) => rank(a) - rank(b))
        .map(([stakeholder, rows]) => ({ stakeholder, total: rows.reduce((s, r) => s + r.value, 0), posts: rows }))
    return {
        stakeholders,
        perType: Object.entries(TYPE_LABELS).map(([key, label]) => ({ key, label, value: perType[key] || 0 })),
    }
}

export default buildParticipationPostsView
